import { ArrowBack } from "@mui/icons-material";
import { Button } from "@mui/material";

const BackButton = (props) => (
  <Button variant="outlined" startIcon={<ArrowBack />} {...props}>
    BACK
  </Button>
);

export default BackButton;
